import homeData from './modules/home';
import aboutData from './modules/about';
import workData from './modules/work';
import contactData from './modules/contact';
import cvData from './modules/cv';
import { replacePlaceholdersInObject } from "@/utils/stringReplacer";
import { dynamicValues } from '@/utils/dynamicValues';


// Zentrale Interfaces für Typensicherheit (könnten auch in /types verschoben werden)
export * from './types';

// Datenstruktur mit Modulen
const rawData = {
  dynamicValues,
  home: homeData,
  about: aboutData,
  work: workData,
  contact: contactData,
  cv: cvData
};

// Runtime-Definition für Edge-Kompatibilität
export const runtime = 'edge';

const data = replacePlaceholdersInObject(rawData);

export default data;